import o from "./highrise1437.mjs";
import r from "./highrise1338.mjs";
function c(t) {
  return o(t, r(t));
}
export {
  c as default
};
